import React, { useState } from "react";

import { Icon } from "@partials";
import { getLocalization } from "@utilities";
import { ExchangeRatesTableType } from "@constants";
import { LocalizationTexts } from "../types";

type RatesTabsProps = {
  localization: LocalizationTexts;
  iconsList: any;
  onChange: (type: ExchangeRatesTableType) => void;
};

const RatesTabs: React.FC<RatesTabsProps> = ({ localization, iconsList, onChange }) => {
  const [isActive, setIsActive] = useState<ExchangeRatesTableType>(ExchangeRatesTableType.Cash);

  /**
   * Handles TABS onChange callback and setIsActive function for "is-active" tab CSS.
   * @param {ExchangeRatesTableType} type - Includes 2 different strings: "cash" | "wire".
   *
   * @returns {void}
   */
  const changeTableType = (type: ExchangeRatesTableType): void => {
    onChange(type);
    setIsActive(type);
  };

  const { cash, wire } = iconsList;

  return (
    <div className="tabs-exchange-rates">
      <button
        type="button"
        data-testid={`tab-${ExchangeRatesTableType.Cash}`}
        className={`tabs-exchange-rates__button mr-2 ${
          isActive === ExchangeRatesTableType.Cash ? "is-active" : ""
        }`}
        onClick={() => changeTableType(ExchangeRatesTableType.Cash)}
      >
        <Icon
          name={cash.name}
          viewBox={cash.viewbox}
          alt={cash.alt}
          svg={cash.svg}
          className="mr-1 inline h-6 w-6 shrink-0 fill-red-corporate"
        />
        {getLocalization(localization, "ExchangeCash")}
      </button>
      <button
        type="button"
        data-testid={`tab-${ExchangeRatesTableType.Wire}`}
        className={`tabs-exchange-rates__button ${
          isActive === ExchangeRatesTableType.Wire ? "is-active" : ""
        }`}
        onClick={() => changeTableType(ExchangeRatesTableType.Wire)}
      >
        <Icon
          name={wire.name}
          viewBox={wire.viewbox}
          alt={wire.alt}
          svg={wire.svg}
          className="mr-1 inline h-6 w-6 shrink-0 fill-red-corporate"
        />
        {getLocalization(localization, "ExchangeWire")}
      </button>
    </div>
  );
};

export default RatesTabs;
